<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->

    <div :class="'apphead ' + theme" v-if="false">
      <div
        class="skin"
        style="float: right; margin-right: 120px; margin-top: 10px"
        v-if="false"
      >
        <img
          @click="changeTheme('light')"
          v-if="theme == 'dark'"
          src="./assets/images/theme_light.png"
        />

        <img
          @click="changeTheme('dark')"
          v-if="theme == 'light'"
          src="./assets/images/theme_dark.png"
        />
      </div>

      <div
        v-if="isLogin"
        style="margin-right: 40px; float: right; height: 70px; overflow: hidden"
      >
        <!-- <span v-if="user" style="color:white"> 欢迎你&nbsp;&nbsp;&nbsp;<span  v-if="user">{{user.name}}</span></span> -->
        <Dropdown style="margin-left: 20px">
          <a
            v-if="user"
            href="javascript:void(0)"
            style="color: #f6ca9d; font-size: 16px"
          >
            {{ user.name }}
            <Icon type="arrow-down-b"></Icon>
          </a>
          <Dropdown-menu slot="list">
            <Dropdown-item v-if="user"
              ><span @click="modifyInfo">个人中心</span></Dropdown-item
            >
            <Dropdown-item v-if="user"
              ><span @click="handleLogout">退出登录</span></Dropdown-item
            >
          </Dropdown-menu>
        </Dropdown>
      </div>

      <div v-if="company">
        <h1 style="color: #f6ca9d">{{ company.name }}</h1>
      </div>
      <div style="height: 20px"></div>
    </div>

    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { setAccessToken } from './utils/api'
import CompanyModel from './components/company/CompanyModel';
import Config from './config'
import SystemSetModel from './components/system/SystemSetModel'
import timeUtils from './utils/timeUtils'

export default {
  name: 'App',

  data () {
    return {
      msg: "",
      isLogin: true,
      loginpath:''
    }
  },

  computed: {

    ...mapGetters("user", ["user", "token"]),
    ...mapGetters("company", ["company", "theme"])

  },
  methods: {
    handleLogout () {
      console.log("handleLogout");
      this.clearUser();
      this.$router.replace({ name: "Login" });
    },
    handleSetting () {
      console.log("handleSetting");

    },
    modifyInfo () {
      this.$router.push({ name: "ModifyInfo" });
    },
    modifyPassword () {
      this.$router.push({ name: "ModifyPwd" });
    },
    changeTheme (theme) {
      this.setTheme(theme);
      less.modifyVars({
        'layout-header-background': 'red'
      });
    },
    ...mapActions('user', ['initUser', 'setUser', 'clearUser']),
    ...mapActions('company', ['companyLogin', 'initCompany', 'initTheme', 'setTheme', 'setGsmc', 'initGsmc', 'setCompanyInfo','settitle']),
  },

  created () {
    // return;
    Config.init();
    this.initTheme();
    let self = this;
    this.initUser();
    this.initGsmc();
    this.initCompany();
    setAccessToken(this.token);

    // console.log("document.domain " + document.domain);

    // SystemSetModel.getSystemSet((res) => {
    //     this.setGsmc(res.cValue);
    // }, (err) => {

    // }, {
    //     id: "GSMC"
    // });

    CompanyModel.getCompanyInfo1((res) => {
      //console.log("res = " + JSON.stringify(res));

	  if (res.name)
	  {this.settitle(res.name);}
      this.setGsmc(res.rname);

      let time1 = "";
      let time2 = "";

      if (res.date && res.date != '') {
        let today = timeUtils.getDay24Time();
        time1 = new Date(today.replace("-", "/").replace("-", "/"));
        time2 = new Date(res.date.replace("-", "/").replace("-", "/"));

        res.isAuth = true;
      } else {
        res.isAuth = false;
      }

	  if (res.remark.indexOf('limitedate')>=0){
		  if (time1 > time2) {
          res.isAuth = false;
        }
	  }
      if (res.version == 'demo' || res.version == 'express') {
        if (time1 > time2) {
          res.isAuth = false;
        }
      } else {
        if (!res.machinecode || res.machinecode == "" || res.machinecode != res.sn) {
          res.isAuth = false;
        }
        // else {
        //     if (time1 > time2) {
        //         res.isAuth = false;
        //     }
        // }
      }
      if (res.module && res.module != '') {
        let tmp = res.module.split(',');
        let tmp1 = [];
        for (let i = 0, len = tmp.length; i < len; i++) {
          if (tmp[i] == "rs") {
            tmp1.push("人事");
          } else if (tmp[i] == "kq") {
            tmp1.push("考勤");
          } else if (tmp[i] == "mj") {
            tmp1.push("门禁");
          } else if (tmp[i] == "xf") {
            tmp1.push("消费");
          } else if (tmp[i] == "cx") {
            tmp1.push("车行通道");
          } else if (tmp[i] == "tk") {
            tmp1.push("梯控");
          } else if (tmp[i] == "sk") {
            tmp1.push("水控");
          } else if (tmp[i] == "xy") {
            tmp1.push("洗衣");
          } else if (tmp[i] == "bc") {
            tmp1.push("班车");
          } else if (tmp[i] == "zk") {
            tmp1.push("证卡");
          } else if (tmp[i] == "dc") {
            tmp1.push("订餐");
          } else if (tmp[i] == "rx") {
            tmp1.push("人行通道");
          } else if (tmp[i] == "wp") {
            tmp1.push("物品领用");
          } else if (tmp[i] == "dj") {
            tmp1.push("消费登记");
          } else if (tmp[i] == "sjcz") {
            tmp1.push("手机充值");
          } else if (tmp[i] == "sjcp") {
            tmp1.push("菜品点餐");
          } else if (tmp[i] == "sjgr") {
            tmp1.push("个人报餐");
          } else if (tmp[i] == "sjjl") {
            tmp1.push("消费查询");
          } else if (tmp[i] == "sjzp") {
            tmp1.push("照片采集");
          } else if (tmp[i] == "ddc") {
            tmp1.push("代订餐");
          } else if (tmp[i] == "sjbm") {
            tmp1.push("团体报餐");
          } else if (tmp[i] == "sjtk") {
            tmp1.push("手机退款");
          } else if (tmp[i] == "czzs") {
            tmp1.push("充值赠送");
          }
        }
        res.modules = tmp1;
      } else {
        res.modules = [];
      }

      this.setCompanyInfo(res);

      if (res.isAuth) {
        // console.log("this.token = " + this.token + " this.user = " + this.user);
        if (this.token && this.user) {

          this.$router.replace({ name: "MainPage" });
        } else {
          console.log("remark = ",res.remark);
          if(res.remark.indexOf('IHRSSO') != -1 || res.remark.indexOf('DingDSSO') != -1){
              this.$router.replace({ name: "LoginSSO" });
          }else
          {
            this.$router.replace({ name: "Login" });
          }

        }
      } else {
        this.$router.replace({ name: "Login" });
      }


    }, (err) => {

    }, {

    });



    // if (this.token && this.user) {
    //     setAccessToken(this.token);
    //     this.$router.replace({name: "MainPage"});
    // } else {
    //     this.$router.replace({name: "Login"});
    // }




  },
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  width: 100%;
  height: 100%;
}
.apphead {
  /* background-color: #2A2B30;
    position: absolute;
    top: 0; */
  width: 100%;
  height: 70px;
  line-height: 70px;
  padding: 0px;
  margin: 0px;
}
.light {
  background-color: white;
}
.dark {
  background-color: #2a74c3;
}
.skin {
  display: inline-block;
  width: 30px;
  height: 30px;
}
.skin img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue